import React from "react";
import HomeScreen from "./Home/HomeScreen";
import ReactDOM from "react-dom";
import Login from "./Moduli/Login";
import Policy from "./Moduli/Policy";
import Jelovnik from "./Moduli/Jelovnik";
import IzmeniRadnika from "./Moduli/IzmeniRadnika";
import { Router, Route, Redirect } from "react-router-dom";
import "./App.css";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import DOMPurify from "dompurify";
import getMuiTheme from "material-ui/styles/getMuiTheme";
import AppBar from "material-ui/AppBar";
import { ListItem } from "material-ui/List";
import Divider from "material-ui/Divider";
import Drawer from "material-ui/Drawer";
import { Link } from "react-router-dom";
import HomeIcon from "material-ui/svg-icons/social/domain";
import PowerIcon from "material-ui/svg-icons/action/power-settings-new";
import HelpIcon from "material-ui/svg-icons/social/whatshot";
import Avatar from "material-ui/Avatar";
import logo from "./Media/logo-mp.jpg";
// relative path to image import Divider from "material-ui/Divider";
import * as Colors from "material-ui/styles/colors";
import configureHistory from "./Helpers/configureHistory.js";
import AuthService from "./Helpers/AuthService";

const history = configureHistory();
const routes = [
    {
        path: "/",
        exact: true,
        sidebar: () => <Login />,
        main: () => <HomeScreen />,
    },
    {
        path: "/home",
        sidebar: () => <Login />,
        main: () => <HomeScreen />,
    },
    {
        path: "/Jelovnik/:idfirme",
        sidebar: () => <div>bubblegum!</div>,
        main: (props) => <Jelovnik {...props} />,
    },
    {
        path: "/IzmeniRadnika/:idfirme/:searchstring",
        sidebar: () => <div>bubblegum!</div>,
        main: (props) => <IzmeniRadnika {...props} />,
    },
];
const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) =>
            rest.auth.loggedIn() ? (
                <Component {...props} />
            ) : (
                <Redirect
                    to={{
                        pathname: "/login",
                        state: { from: props.location },
                    }}
                />
            )
        }
    />
);
const muiTheme = getMuiTheme({
    palette: {
        textColor: Colors.darkBlack,
        primary1Color: "#8FDC35",
        primary2Color: Colors.indigo700,
        pickerHeaderColor: Colors.darkBlack,
        alternateTextColor: Colors.white,
    },
});
export default class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            width: "0",
            height: "0",
            user: { ime: "", prezime: "" },
        };
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
        this.toggleDrawer = this.toggleDrawer.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.Auth = new AuthService();
    }
    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener("resize", this.updateWindowDimensions);
        this.osveziProfil();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateWindowDimensions);
        this.unlisten();
    }

    componentWillMount() {
        this.unlisten = history.listen((location, action) => {
            this.osveziProfil();
        });
    }

    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    toggleDrawer() {
        console.log("toggle");

        this.setState({
            open: !this.state.open,
        });
    }
    handleClose() {
        console.log("close");
        this.setState({ open: false });
    }

    logout() {
        console.log("logout");
        this.setState({ open: false, user: [] });
        this.Auth.logout();
    }

    osveziProfil = () => {
        let user = this.Auth.getProfile();
        if (user !== null) this.setState({ user: user });
    };

    render() {
        const contentStyle = { flex: 1 };
        if (this.state.open) {
            //contentStyle.marginLeft = 256;
        }
        return (
            <Router history={history}>
                <div style={{ display: "flex" }}>
                    <div style={contentStyle}>
                        <MuiThemeProvider muiTheme={muiTheme}>
                            <div>
                                <AppBar
                                    title="StoryDash"
                                    style={{ position: "fixed" }}
                                    titleStyle={{
                                        fontWeight: "bold",
                                        fontFamily: "Raleway",
                                    }}
                                    onLeftIconButtonTouchTap={this.toggleDrawer}
                                    iconStyleLeft={{ fontWeight: "bold" }}
                                ></AppBar>
                                <Drawer
                                    width={256}
                                    disableSwipeToOpen={false}
                                    docked={false}
                                    open={this.state.open}
                                    onRequestChange={(open) =>
                                        this.setState({ open })
                                    }
                                >
                                    <ListItem
                                        className="drawerHeader"
                                        leftAvatar={
                                            <Avatar
                                                className="avatarHeader"
                                                style={{
                                                    borderRadius: 20,
                                                    border: "1px solid gray",
                                                }}
                                                size={70}
                                                src={logo}
                                            />
                                        }
                                        disabled={true}
                                        style={{
                                            flexDirection: "column",
                                            display: "flex",
                                            fontFamily: "Raleway",
                                            background: "#8FDC35",
                                            color: "white",
                                            fontWeight: "bold",
                                            height: 24,
                                            textAlign: "right",
                                        }}
                                        hoverColor={Colors.greenA700}
                                    >
                                        <label
                                            style={{
                                                fontSize: 24,
                                                marginBottom: 7,
                                            }}
                                        >
                                            StoryDash{" "}
                                        </label>
                                        <label style={{ fontSize: 12 }}>
                                            {this.state.user.ime}{" "}
                                            {this.state.user.prezime}
                                        </label>
                                    </ListItem>
                                    <br />
                                    <ListItem
                                        containerElement={<Link to="/Home" />}
                                        primaryText="Firme"
                                        leftIcon={<HomeIcon />}
                                        onClick={() => {
                                            this.handleClose();
                                        }}
                                    />
                                    <Divider />
                                    <ListItem
                                        onClick={() => {
                                            this.logout();
                                        }}
                                        primaryText="Odjavi me"
                                        leftIcon={<PowerIcon />}
                                    />{" "}
                                    <Divider />
                                    <ListItem
                                        containerElement={<Link to="/Pomoc" />}
                                        primaryText="Pomoć"
                                        leftIcon={<HelpIcon />}
                                    />{" "}
                                    <Divider />
                                </Drawer>
                            </div>
                        </MuiThemeProvider>
                        <div style={{ marginTop: "45px" }}>
                            {routes.map((route, index) => (
                                <PrivateRoute
                                    key={index}
                                    path={route.path}
                                    exact={route.exact}
                                    component={route.main}
                                    auth={this.Auth}
                                    onEnter={this.gaga}
                                />
                            ))}
                            <Route
                                exact
                                path="/login"
                                onEnter={this.gaga}
                                component={Login}
                            />
                            <Route
                                exact
                                path="/policy.html"
                                onEnter={()=> window.location.reload()}
                                component={Policy}
                            />
                        </div>
                    </div>
                </div>
            </Router>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App.js